import React, { PointerEvent } from 'react';
import { BlindActionEnum } from 'lavva.exalushome/build/js/Services/Devices/Tasks/Tasks';
import { ControlWrapper, Slider, SubmitButton } from '../../../components';
import { BlindDetailsSimpleControlButtons } from '../../../components/channel-details-controls/blind-simple';
import { BlindDetailsControls } from '../../../components/channel-details-controls/blind/controls';
import { BlindDetailsFavourites } from '../../../components/channel-details-controls/blind/favourites';
import { defaultFavouritePositionList } from '../../../const';
import { BlindStateDirectionInternal } from '../../../data-access/gql-types/graphql';

type BlindChannelSettingsCommonProps = {
  sliderValue: number;
  handleSliderEvent: (event: PointerEvent<HTMLInputElement>) => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  setSliderValue: (value: React.SetStateAction<number>) => void;
  handleConstPercentageChange: (pos: number) => void;
  handleSubmit: () => void;
};

type LavvaBlindProps = BlindChannelSettingsCommonProps & {
  kind?: 'lavva';
  blindAction: BlindStateDirectionInternal;
  setBlindAction: (value: React.SetStateAction<BlindStateDirectionInternal>) => void;
};

type ExalusBlindProps = Omit<BlindChannelSettingsCommonProps, 'kind'> & {
  kind: 'exalus';
  setBlindAction: (value: React.SetStateAction<BlindActionEnum>) => void;
  blindAction: BlindActionEnum;
  isViewSimple: boolean;
};

type BlindChannelSettingsProps = LavvaBlindProps | ExalusBlindProps;

export const BlindChannelSettings: React.FC<BlindChannelSettingsProps> = (props) => {
  const { sliderValue, handleSliderEvent, onChange, setSliderValue, handleConstPercentageChange, handleSubmit } = props;
  const isExalusBlind = props.kind === 'exalus';

  const viewSimple = isExalusBlind ? props.isViewSimple : false;

  const isOpened =
    props.kind === 'exalus'
      ? props.blindAction === BlindActionEnum.Open
      : props.blindAction === BlindStateDirectionInternal.Open;

  const isClosed =
    props.kind === 'exalus'
      ? props.blindAction === BlindActionEnum.Close
      : props.blindAction === BlindStateDirectionInternal.Closed;

  const isStopped =
    props.kind === 'exalus'
      ? props.blindAction === BlindActionEnum.Stop
      : props.blindAction === BlindStateDirectionInternal.Stopped;

  return (
    <>
      <ControlWrapper>
        {!viewSimple ? (
          <Slider value={sliderValue} onPointerUp={handleSliderEvent} onChange={onChange} />
        ) : (
          <BlindDetailsSimpleControlButtons
            open={() => {
              setSliderValue(0);
              if (isExalusBlind) props.setBlindAction(BlindActionEnum.Open);
            }}
            stop={() => {
              if (isExalusBlind) props.setBlindAction(BlindActionEnum.Stop);
            }}
            close={() => {
              setSliderValue(100);
              if (isExalusBlind) props.setBlindAction(BlindActionEnum.Close);
            }}
            isOpened={isOpened}
            isClosed={isClosed}
            isStopped={isStopped}
          />
        )}
      </ControlWrapper>
      {!viewSimple && (
        <>
          <BlindDetailsControls
            downButton={{
              handleClick: () => {
                setSliderValue(100);
                if (!isExalusBlind) props.setBlindAction(BlindStateDirectionInternal.Closed);
                else props.setBlindAction(BlindActionEnum.Close);
              },
              active: isClosed,
            }}
            stopButton={{
              handleClick: () => {
                if (!isExalusBlind) props.setBlindAction(BlindStateDirectionInternal.Stopped);
                else props.setBlindAction(BlindActionEnum.Stop);
              },
              active: isStopped,
            }}
            upButton={{
              handleClick: () => {
                setSliderValue(0);
                if (!isExalusBlind) props.setBlindAction(BlindStateDirectionInternal.Open);
                else props.setBlindAction(BlindActionEnum.Open);
              },
              active: isOpened,
            }}
          />
          <BlindDetailsFavourites
            favouritePositionList={defaultFavouritePositionList}
            onFavouriteClick={handleConstPercentageChange}
            icon="blind"
          />
        </>
      )}

      <SubmitButton onClick={handleSubmit} />
    </>
  );
};
